// usePatientDigitalTwins.js
import { useLazyQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { GET_PATIENT_DIGITAL_TWINS_IDS } from "../../queries/patientQueries";

export function usePatientDigitalTwins(patientId) {
  const [patientDigitalTwinIds, setPatientDigitalTwinIds] = useState([]);

  const [getPatientDigitalTwinIds, { loading, error }] = useLazyQuery(
    GET_PATIENT_DIGITAL_TWINS_IDS,
    {
      fetchPolicy: "network-only",
      onError: error => {},
    }
  );

  const fetchPatientDigitalTwinIds = useCallback(async () => {
    if (!patientId) return;
    try {
      const { data } = await getPatientDigitalTwinIds({
        variables: { patientId },
        fetchPolicy: "network-only", // Force network request instead of cache
      });

      if (data && data.patientById && data.patientById.digital_twins_ids) {
        setPatientDigitalTwinIds(data.patientById.digital_twins_ids);

        return data.patientById.digital_twins_ids; // Return the IDs for chaining
      }
      return [];
    } catch (error) {
      return [];
    }
  }, [patientId, getPatientDigitalTwinIds]);

  useEffect(() => {
    // Reset state when patient changes
    setPatientDigitalTwinIds([]);
  }, [patientId]);

  return {
    patientDigitalTwinIds,
    fetchPatientDigitalTwinIds,
    loading,
    error,
  };
}
